import { render, staticRenderFns } from "./aiSymptom.vue?vue&type=template&id=0de4d0ce&scoped=true&"
import script from "./aiSymptom.vue?vue&type=script&lang=js&"
export * from "./aiSymptom.vue?vue&type=script&lang=js&"
import style0 from "./aiSymptom.vue?vue&type=style&index=0&id=0de4d0ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de4d0ce",
  null
  
)

export default component.exports